import { RootState } from "../../store";

export const getReserveGrunts = (state: RootState) => state.getGrunt;
